import { inject } from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from "@core/services/auth.service";


export const AuthGuard = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Token présent mais expiré : déconnecter et renvoyer au login même sans appel HTTP
    // (navigation pure). logout() nettoie le token/utilisateur et redirige.
    if (authService.isAuthenticated() && authService.isTokenExpired()) {
        authService.logout();
        return false;
    }

    if (authService.isAuthenticated()) {
        if (authService.hasToChangePassword()) {
            router.navigate(['/auth/first-change']);
            return false;
        }
        return true;
    }

    router.navigate(['/auth/login']);
    return false;
};
